module.exports = __webpack_public_path__ + "assets/word_cost_control_highlight.82587f5e.svg";